import React from "react";

const Divider: React.FC = () => {
	return <hr className="my-4" />;
};

export default Divider;
